import { ROUTES } from "@utils/navigation";

export function getNotificationHref(
  entityType: string | null,
  entityId: string | null,
) {
  if (entityType === "request" && entityId)
    return ROUTES.REQUEST_DETAIL(entityId);
  if (entityType === "commute" && entityId)
    return ROUTES.COMMUTE_DETAIL(entityId);
  return ROUTES.NOTIFICATIONS;
}
